export default [{
  path: '/test',
  redirect: { name: 'testPage' }
},
{
  path: '/test/action',
  name: 'testPage',
  component: () => import(/* webpackChunkName: "referralActivityPage" */ '@/views/test/action.vue')
},
{
  path: '/test/review',
  name: 'testReview',
  component: () => import(/* webpackChunkName: "referralActivityPage" */ '@/views/test/review.vue')
}]
